module.exports = "./img/c20d8755dd41ed049a01c2455512de94.png";